import { getSessionStatusDisplay } from '@efdigital/ll-addon-coaching/utils/coaching-sessions/session-display';
import type { CoachingSessionType } from '@efdigital/ll-addon-data';
import { Heading } from '@efdigital/ll-addon-ui';
import { SessionsList } from '@efdigital/ll-admin-v2/components/coaching/sessions/sessions-list.gts';
import { SearchSessions } from '@efdigital/ll-admin-v2/components/search/search-sessions.gts';
import type CoachingSessionsIndexController from '@efdigital/ll-admin-v2/controllers/coaching/sessions/index';
import {
  findSessionStatusGroup,
  isAllStatuses,
} from '@efdigital/ll-admin-v2/utils/coaching/coaching-sessions/session-state';
import Component from '@glimmer/component';

function sessionTypeLabel(sessionType: CoachingSessionType | ''): string {
  switch (sessionType) {
    case 'coaching':
      return 'Coaching sessions';
    case 'chemistry':
      return 'Chemistry sessions';
    default:
      return 'Sessions';
  }
}

interface SessionsIndexSignature {
  Args: {
    controller: CoachingSessionsIndexController;
  };
}

export default class SessionsIndexRoute extends Component<SessionsIndexSignature> {
  get title() {
    const sessions = sessionTypeLabel(this.args.controller.sessionType);

    if (isAllStatuses(this.args.controller.statuses)) {
      return sessions;
    }
    const group = findSessionStatusGroup(this.args.controller.statuses);
    if (group) {
      return group.title.replace(/sessions/gi, sessions);
    }
    if (this.args.controller.statuses.length === 1) {
      const display = getSessionStatusDisplay(
        this.args.controller.statuses[0]!
      );
      if (display) {
        return `${sessions}: ${display.uniqueLabel}`;
      }
    }
    return `${sessions}: Custom filter`;
  }

  <template>
    <div class="container py-5">
      <SearchSessions
        @state={{@controller}}
        @setState={{@controller.setState}}
        @filters={{@controller.filters}}
        @legend="Sessions"
        class="mb-5"
      >
        <:query as |query|>
          <Heading @text={{this.title}} />

          <SessionsList
            @query={{query}}
            @offset={{@controller.offset}}
            @limit={{@controller.limit}}
            @onOffsetChange={{@controller.setOffset}}
          />
        </:query>
      </SearchSessions>
    </div>
  </template>
}
